import { render, staticRenderFns } from "./Users-reports.vue?vue&type=template&id=6dab4c8b&scoped=true"
import script from "./Users-reports.vue?vue&type=script&lang=js"
export * from "./Users-reports.vue?vue&type=script&lang=js"
import style0 from "./Users-reports.vue?vue&type=style&index=0&id=6dab4c8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dab4c8b",
  null
  
)

export default component.exports